import { Box, DialogActions, SvgIcon, Typography } from '@mui/material'
import * as React from 'react'
import { useRef } from 'react'

import ExternalURLIcon from '@hapana/shared/web/styles/assets/svgs/external-link.svg'
import Button from '../../../button/button.component'
import { BUTTON_SIZE, BUTTON_THEME, BUTTON_VARIANTS } from '../../../button/button.constants'
import { commonStyles } from '../../../../../styles/common.styles'

import { PROP_TYPES } from './dialog-footer.constants'
import { styles } from './dialog-footer.styles'

const DialogFooter = ({
  externalURL,
  primaryAction,
  tertiaryAction,
  icon,
  secondaryAction,
  customFooterContent,
}) => {
  const primaryActionButtonRef = useRef()
  const secondaryActionButtonRef = useRef()
  const tertiaryActionButtonRef = useRef()
  const externalUrlButtonRef = useRef()

  return (
    <DialogActions sx={styles.container}>
      {(externalURL || tertiaryAction || customFooterContent) && (
        <Box sx={styles.externalURLAndTertiaryAction}>
          {externalURL && (
            <>
              <Box sx={styles.externalURL}>
                <Button
                  size={BUTTON_SIZE.MEDIUM}
                  variant={BUTTON_VARIANTS.ICON}
                  onClick={() => window.open(externalURL, '_blank')}
                  icon={ExternalURLIcon}
                  type="button"
                  ref={externalUrlButtonRef}
                />
              </Box>

              <Box sx={styles.divider}></Box>
            </>
          )}
          {tertiaryAction && (
            <Box sx={styles.tertiaryAction}>
              <Button
                size={BUTTON_SIZE.MEDIUM}
                variant={BUTTON_VARIANTS.TEXT}
                onClick={tertiaryAction.action}
                startIcon={tertiaryAction.icon}
                label={tertiaryAction.label}
                type="button"
                {...(tertiaryAction.props && {
                  sx: tertiaryAction.props?.styles,
                })}
                {...(tertiaryAction.action && {
                  onClick: tertiaryAction.action,
                })}
                ref={tertiaryActionButtonRef}
                {...tertiaryAction.props}
              />
            </Box>
          )}

          {customFooterContent && (
            <Box sx={styles.customFooterContent}>
              {customFooterContent && icon && <SvgIcon component={icon} sx={styles.iconStyling} />}
              <Typography typography="medium" color="gray.40">
                {customFooterContent}
              </Typography>
            </Box>
          )}
        </Box>
      )}
      <Box sx={styles.actions}>
        {secondaryAction && (
          <Box sx={styles.secondaryActionContainer} {...secondaryAction.containerProps}>
            <Button
              test-id={secondaryAction.label}
              label={secondaryAction.label}
              size={BUTTON_SIZE.LARGE}
              isLoading={secondaryAction.isLoading}
              variant={secondaryAction.variant ? secondaryAction.variant : BUTTON_VARIANTS.OUTLINED}
              theme={secondaryAction.theme ? secondaryAction.theme : BUTTON_THEME.GRAY}
              {...(secondaryAction.icon && { startIcon: secondaryAction.icon })}
              onClick={secondaryAction.action}
              type="button"
              sx={[
                styles.secondaryAction,
                secondaryAction?.props && secondaryAction?.props?.styles,
              ]}
              ref={secondaryActionButtonRef}
              {...secondaryAction.props}
            />
          </Box>
        )}
        {primaryAction && (
          <Box
            sx={[primaryAction.fullWidth ? commonStyles.fullWidth : styles.primaryActionContainer]}
            {...primaryAction.containerProps}
          >
            <Button
              test-id={primaryAction.label}
              label={primaryAction.label}
              startIcon={primaryAction.icon}
              size={BUTTON_SIZE.LARGE}
              variant={primaryAction.variant ? primaryAction.variant : BUTTON_VARIANTS.CONTAINED}
              theme={primaryAction.theme ? primaryAction.theme : BUTTON_THEME.PRIMARY}
              isLoading={primaryAction.isLoading}
              sx={[
                primaryAction.fullWidth ? commonStyles.fullWidth : styles.primaryAction,
                primaryAction?.props && primaryAction?.props?.styles,
              ]}
              ref={primaryActionButtonRef}
              {...(primaryAction.action && {
                onClick: primaryAction.action,
              })}
              {...primaryAction.props}
            />
          </Box>
        )}
      </Box>
    </DialogActions>
  )
}

DialogFooter.propTypes = PROP_TYPES

export default DialogFooter
